export const VIDEO_TABLE_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Video Name",
    sortable: false,
    resizable: true
  },
  {
    key: "id",
    dataKey: "id",
    title: "Watch Video",
    sortable: false,
    resizable: false
  },
  {
    key: "createdAt",
    dataKey: "createdAt",
    title: "Date Created",
    sortable: false,
    resizable: true
  },
  {
    key: "share",
    dataKey: "id",
    title: "",
    sortable: false,
    resizable: true
  }
];

export const BROADCAST_TABLE_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Video Name",
    sortable: false,
    resizable: true
  },
  {
    key: "productName",
    dataKey: "productName",
    title: "Product Name",
    sortable: false,
    resizable: true
  },
  {
    key: "scheduleStartDate",
    dataKey: "scheduleStartTime",
    title: "Scheduled Date",
    sortable: false,
    resizable: true
  },
  {
    key: "createdAt",
    dataKey: "createdAt",
    title: "Date Created",
    sortable: false,
    resizable: true
  },
  {
    key: "startBroadcast",
    dataKey: "id",
    title: "Start Broadcast",
    sortable: false,
    resizable: true
  },
  {
    key: "share",
    dataKey: "id",
    title: "",
    sortable: false,
    resizable: true
  }
];

export const ARCHIVED_TABLE_COLUMNS = [
  {
    key: "name",
    dataKey: "name",
    title: "Video Name",
    sortable: false,
    resizable: true
  },
  {
    key: "id",
    dataKey: "id",
    title: "Watch Video",
    sortable: false,
    resizable: false
  },
  {
    key: "createdAt",
    dataKey: "createdAt",
    title: "Date Created",
    sortable: false,
    resizable: true
  },
  {
    key: "unarchive",
    dataKey: "id",
    title: "Unarchive",
    sortable: false,
    resizable: true
  },
  {
    key: "reporting",
    dataKey: "id",
    title: "Add to Report",
    sortable: false,
    resizable: true
  }
];
